var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4995 2.01025C10.328 2.01025 2.89844 9.43981 2.89844 18.6114C2.89844 27.7829 10.328 35.2125 19.4995 35.2125C28.6711 35.2125 36.1007 27.7829 36.1007 18.6114C36.1007 9.43981 28.6637 2.01025 19.4995 2.01025ZM23.7876 18.6114H21.0703V28.572H17.3407V18.6114H14.8542V15.1795H17.3407L17.3332 13.1546C17.3332 10.3555 18.0925 8.6507 21.3904 8.6507H24.1374V12.0826H22.4178C21.1299 12.0826 21.0703 12.559 21.0703 13.4598L21.0629 15.1795H24.1523L23.7876 18.6114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebookLogo.1139dd3cdfd65c05b7cbdfca1111ed50.svg";
export { ForwardRef as ReactComponent };